//outsource
import { Row, Col, Divider, Typography } from "antd";

//components

const { Text } = Typography;
const SelectedServices = ({ selectedService }) => {
  // -------------------------- VAR --------------------------
  const title = "Services for consultation";

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION -----------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <div className="booking-selected">
      <Text
        strong
        style={{
          display: "block",
          marginTop: 10,
          marginBottom: 5,
          marginLeft: 10,
          textAlign: "left",
        }}
      >
        {title}
      </Text>
      <Divider
        style={{
          width: "100%",
          margin: "0 0",
        }}
      />
      {selectedService?.map((item) => {
        console.log("item", item);
        return (
          <Row
            key={item?.service}
            style={{
              margin: "1rem 0rem",
              // fontWeight: "bold",
            }}
            gutter={[10]}
            align="top"
          >
            <Col align="left" flex="auto" span={24}>
              <Text
                style={{
                  marginLeft: 20,
                }}
              >
                • {item?.name}
              </Text>
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

export default SelectedServices;
